module.exports = "https://static.wanderu.com/ui-react/_next/static/media/carriers.5482f4f1.png";